import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025SistemasDeMedicion() {
  return <CategoryPage category="anexo30Y31Ano2025SistemasDeMedicion" pageTitle="Sistemas De Medicion 2025" />;
}

export default Anexo30Y31Ano2025SistemasDeMedicion;
